'use strict';

var util = angular.module('gymsystem.util');

util.directive('reportwidget', ['propertyhelper', function(propertyhelper) {
    return {
        restrict: 'E',
        template: '<div class="panel-body"><showreport info="info" report-id="report_id" option="option" /></div>',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $scope.option = {hideHeader: true, keyvaluecenter: true, showMailing: true};
            propertyhelper.getInfo().then(function(result) {
                $scope.info = result;
                $scope.report_id = $scope.settings.report_id;
            });
        }
    };
}]);
